export default __webpack_public_path__ + "static/media/step4.3cdae6c3.png";